import axios from 'axios'
import { backendUrl } from '../../config/config'


const getMessagesById = async (sessionId) => {
  const messageResponse = await axios.get(`${backendUrl}/api/messages/${sessionId}`)
  const messages = []
  messageResponse.data.forEach(message => {
    messages.push(message)
  });
  return messages
}

 export {
   getMessagesById
 }